var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-toolbar',{attrs:{"title-visible":false}}),_c('app-footer'),_c('v-content',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }